import { AxiosInstance } from "../../../axios/axiosInstance"
import { apiRoutes } from "../../../utils/ApiRoutes"
import { IAddBusinessData } from "../IApisInterface"

export const getUserKeysApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.userKeys)
    return response
}

export const getBusinessApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.getBusiness)
    return response
}

export const addBusinessApi = async (payload: IAddBusinessData) => {
    const response = await AxiosInstance.post(apiRoutes?.addBusiness, payload)
    return response
}

export const addAllBusinessApi = async (placeIds: string[]) => {
    const response = await AxiosInstance.post(apiRoutes?.addAllBusiness, { placeIds })
    return response
}

export const deleteBusinessApi = async (id: string) => {
    const response = await AxiosInstance.delete(`${apiRoutes?.deleteBusinessById}/${id}`)
    return response
}

// export const getGbpBusinessApi = async () => {
//     const response = await AxiosInstance.get(apiRoutes?.getGbp)
//     return response
// }

export const getGbpBusinessPaginatedApi = async (payload: { page: number, limit: number, keyword: string, email: string, sort_by?: string, sort_order?: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.getGbpPaginated, payload)
    return response
}

export const addGbpBusinessApi = async (token: string) => {
    const response = await AxiosInstance.post(apiRoutes?.addGbp, { token })
    return response
}